import axios from 'axios'
import Message from 'ant-design-vue/lib/message'
import 'ant-design-vue/lib/message/style'

import router from '@/router'
// 測試 api https://msgrply.biboting.com/
// 正式 api https://cscn.biboting.com/
const BASE_API =
  process.env.NODE_ENV === 'production'
    ? 'https://cscn.biboting.com.cn/api' : 'https://cscn.wulidev.com/api'
const service = axios.create({
  app: 'admin',
  baseURL: BASE_API,
  timeout: 60000
})

service.interceptors.request.use(config => {
  // store.dispatch('showLoading')
  config.headers = {
    ...config.headers,
    app: 'admin'
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    // setTimeout(() => {
    //   store.dispatch('hideLoading')
    // }, 100)
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 500:
          setTimeout(() => {
            Message.error('错误：' + error.response.status + '伺服器忙线中，请稍候再试', 0.5)
          }, 500)
          break
      }
      router.push({
        path: '/'
      })
    }
    return Promise.reject(error)
    // }
  })

export default service
